import React from "react";
import summaryIcon from "assets/images/summary.png";
import "./approved-proof-order-summary.css";

export type ApprovedProofOrderSummaryViewProps = {
  orderSummary?: string;
};

/** Read-only internal summary (signage / signageteammember). Hidden when empty. */
export default function ApprovedProofOrderSummaryView({ orderSummary = "" }: ApprovedProofOrderSummaryViewProps) {
  const saved = String(orderSummary || "").trim();
  if (!saved) return null;

  return (
    <div className="pq-proof-order-summary">
      <div className="pq-proof-order-summary-head">
        <div className="pq-proof-order-summary-title">
          <img src={summaryIcon} alt="" className="pq-proof-order-summary-icon" aria-hidden />
          <span>SUMMARY</span>
        </div>
        <span className="pq-proof-order-summary-hint">Internal notes only</span>
      </div>
      <div className="pq-proof-order-summary-view-wrap">
        <div className="pq-proof-order-summary-view">
          <p className="pq-proof-order-summary-text">{saved}</p>
        </div>
      </div>
    </div>
  );
}
